/**
 * https://gist.github.com/takien/4077195#gistcomment-2184219
 * @param   {String} urlString
 * @returns {String}
 */
export default function getYoutubeId(urlString) {
  const urlAfterSplit = urlString.split(
    /(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/,
  );

  return undefined !== urlAfterSplit[2]
    ? urlAfterSplit[2].split(/[^0-9a-z_-]/i)[0]
    : null;
}
